import PropTypes from 'prop-types';
import DefineRateForm from './DefineRateForm';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
  FormGroup,
  InputGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';

class DefineRate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        definedRate:{
          suiteRate: 0,
          doubleRate: 0,
          kingRate: 0,
          twobedRate:0,
          juniorsuiteRate:0,
          twobedroomsuiteRate:0,
        },
        suite:0,
        double:0,
        king:0,
        twobed:0,
        juniorsuite:0,
        twobedroomsuite:0
    };

    this.handleSubmitForRate = this.handleSubmitForRate.bind(this);
    this.checkValues = this.checkValues.bind(this);
  }

  checkValues(values){
    let suite =values.suiteRate.toString();
    let double = values.doubleRate.toString();
    let king = values.kingRate.toString();
    let twobed = values.twobedRate.toString();
    let juniorsuite = values.juniorsuiteRate.toString();
    let twobedroomsuite = values.twobedroomsuiteRate.toString();
  
    if((suite.startsWith("00")) || (double.startsWith("00")) || (king.startsWith("00")) || (twobed.startsWith("00")) || (juniorsuite.startsWith("00")) || (twobedroomsuite.startsWith("00")) ){
      alert("Please enter valid number")
    }else{
      this.handleSubmitForRate(values)
    }
  }
  handleSubmitForRate(values) {
    let suiteRate = values.suiteRate ? values.suiteRate : 0;
    let doubleRate = values.doubleRate ? values.doubleRate : 0;
    let kingRate = values.kingRate ? values.kingRate : 0;
    let twobedRate = values.twobedRate ? values.twobedRate : 0;
    let juniorsuiteRate = values.juniorsuiteRate ? values.juniorsuiteRate : 0;
    let twobedroomsuiteRate = values.twobedroomsuiteRate ? values.twobedroomsuiteRate : 0;

    this.setState({ 
      definedRate: {
        suiteRate: suiteRate,
        doubleRate: doubleRate,
        kingRate: kingRate,
        twobedRate: twobedRate,
        juniorsuiteRate: juniorsuiteRate,
        twobedroomsuiteRate: twobedroomsuiteRate

      },
      suite: suiteRate,
      double: doubleRate,
      king: kingRate,
      twobed:twobedRate,
      juniorsuite:juniorsuiteRate,
      twobedroomsuite:twobedroomsuiteRate
    });    

    let bidDetailTableData = this.props.bid_details_input.bidData;
    for (let i = 0; i < bidDetailTableData.length; i++) {
      if(bidDetailTableData[i].roomType==='Suite'){
        bidDetailTableData[i].rate_per_night = suiteRate;

      }
      else if(bidDetailTableData[i].roomType==='King'){
        bidDetailTableData[i].rate_per_night = kingRate;
      }
      else if(bidDetailTableData[i].roomType==='Double'){
        bidDetailTableData[i].rate_per_night = doubleRate;
      }
      else if(bidDetailTableData[i].roomType==='Two Beds'){
        bidDetailTableData[i].rate_per_night = twobedRate;
      }
      else if(bidDetailTableData[i].roomType==='Junior Suite'){
        bidDetailTableData[i].rate_per_night = juniorsuiteRate;
      }
      else if(bidDetailTableData[i].roomType==='2 Bedroom Suite'){
        bidDetailTableData[i].rate_per_night = twobedroomsuiteRate;
      }
    }
    this.props.closeDefineRateModal();
    this.props.calculateAndUpdateTotalValue(this.props.bid_details_input);
  }

 
  
  
  
  
  checkBoxValue(){
    let bidDetailTableData = this.props.bid_details_input.bidData;
    for (let i = 0; i < bidDetailTableData.length; i++) {
      if(bidDetailTableData[i].roomType==='Suite'){
        bidDetailTableData[i].rate_per_night
      }
      else if(bidDetailTableData[i].roomType==='King'){
        bidDetailTableData[i].rate_per_night;
      }
      else if(bidDetailTableData[i].roomType==='Double'){
        bidDetailTableData[i].rate_per_night;
      }
      else if(bidDetailTableData[i].roomType==='Two Beds'){
        bidDetailTableData[i].rate_per_night;
      }
      else if(bidDetailTableData[i].roomType==='Junior Suite'){
        bidDetailTableData[i].rate_per_night;
      }
      else if(bidDetailTableData[i].roomType==='2 Bedroom Suite'){
        bidDetailTableData[i].rate_per_night;
      }
    }
    this.props.calculateAndUpdateTotalValue(this.props.bid_details_input);
    this.props.changeStateValue();
    // this.unCheckBoxValue();
  }

  unCheckBoxValue(){
    let value = this.props.bid_details_input.bidData;
    value.map(a=>{
      if(a.isDisable==true){
        if(a.Suite==0 && a.King==0 && a.Double==0){
          console.log("value of a",a)
          a.rate_per_night =0
        }
      }
    })
    this.props.calculateAndUpdateTotalValue(this.props.bid_details_input);
  }


  render(){
    if(this.props.changeCheckBoxValue!=false){
      this.checkBoxValue();
    }
    console.log("define rate render called");
    return (
      <Modal show={this.props.showDefineRateModalFlag} onHide={this.props.closeDefineRateModal}>
        <Modal.Header closeButton>
          <Modal.Title>Define Rate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <DefineRateForm
            onSubmit={this.checkValues}
            initialValues={this.state.definedRate}
        />
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DefineRate;



// WEBPACK FOOTER //
// src/routes/tours/components/DefineRateModal.js